import type { FaireThemeEntity } from "../../entity_types/theme";

export const clean_and_green_essentials: FaireThemeEntity = {
  token: "clean-and-green-essentials",
  type: "theme",
  name: "Clean & Green Essentials",
  description: "Non-toxic, plant-based solutions for everyday health. High-quality ingredients at a value-driven price point for eco-conscious shoppers.",
  teaser: "Your profile highlights strong interests in natural ingredients, non-toxic formulas, and organic materials, which aligns with your customer base's preference for sustainable products.",
  detail: "The Immunity Spray in the payload is made with 100% pure therapeutic grade essential oils and colloidal silver, supporting your store's 'clean' and 'organic' quality signals.",
  bgColor: "#F0E4D4",
  tileBgColor: "#4a6b36",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_8ih4abkp",
    "p_mna0e5vjkz",
    "p_exjnndytdg",
    "p_83nqu2qz8s",
    "p_rcszdb9nmw",
    "p_m59xpenuff",
    "p_wm54pkqmf7",
    "p_afg92bgtfe",
    "p_ao37ksak",
    "p_bhrubdn47g",
    "p_9hu8nc34k4",
    "p_xjheud2fr3",
    "p_ep3mg42k6c",
    "p_4sye5xrkaf",
    "p_qd762ybpy3",
    "p_enyc5e7h44",
    "p_9flnk96wdf",
    "p_nevyjxf2us",
    "p_j63pst3br2",
    "p_78u9cax86j",
    "p_x35bmvrmbj",
    "p_d6wxnhfp",
    "p_3auuoqfajy",
    "p_b3q9hhadas",
    "p_x9sq93qvb8",
    "p_p2ctth6m5y",
    "p_qt4k3gc3qv",
    "p_4ceq2swg42",
    "p_9cxlauo4jw",
    "p_utpfzacrsz",
    "p_eilldhxk54",
    "p_18f57pw7fg",
    "p_kzf4azpurn",
    "p_7rbzxz9sh4",
    "p_q6cv5bju49",
    "p_xbhwsqkamq",
    "p_xzh9x8qew5",
    "p_m4sqtmz375",
    "p_cz29ns968m",
    "p_x2cq6nkvys",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
